import React, { useState, useEffect, startTransition } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import logo from '../../assets/images/zone-icon.png';
import styles from './Navbar.module.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20); // Déclenche un peu plus tard
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = () => {
    navigate('/');
    setIsMenuOpen(false);
    startTransition(() => logout());
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const getNavLinkClass = ({ isActive }) => {
    return `${styles['nav-link']} ${isActive ? styles.active : ''}`;
  };

  return (
    <header
      className={`${styles['navbar-container']} ${isScrolled ? styles.scrolled : ''}`}
    >
      {/* Logo */}
      <NavLink to="/" onClick={closeMenu} style={{ display: 'flex', alignItems: 'center' }}>
        <img src={logo} alt="AKM Logo" className={styles['navbar-logo']} />
      </NavLink>

      {/* Navigation Desktop & Mobile */}
      <nav
        className={`${styles['navbar-nav']} ${isMenuOpen ? styles.open : ''}`}
        id="main-nav"
      >
        <ul className={styles['nav-list']}>
          {/* Lien Dashboard / Accueil */}
          {user?.type === 'Admin' ? (
            <li className={styles['nav-item']}>
              <NavLink to="/admin-dashboard" className={getNavLinkClass} onClick={closeMenu}>
                Dashboard
              </NavLink>
            </li>
          ) : (
            <>
              <li className={styles['nav-item']}>
                <NavLink to="/home" className={getNavLinkClass} onClick={closeMenu}>
                  Accueil
                </NavLink>
              </li>
              <li className={styles['nav-item']}>
                <NavLink to="/support" className={getNavLinkClass} onClick={closeMenu}>
                  Support & RDV
                </NavLink>
              </li>
            </>
          )}

          {/* Onglets Admin */}
          {user?.type === 'Admin' && (
            <>
              <li className={styles['nav-item']}>
                <NavLink to="/admin/resources" className={getNavLinkClass} onClick={closeMenu}>
                  Consultants
                </NavLink>
              </li>
              <li className={styles['nav-item']}>
                <NavLink to="/admin/clients" className={getNavLinkClass} onClick={closeMenu}>
                  Partenaires
                </NavLink>
              </li>
              <li className={styles['nav-item']}>
                <NavLink to="/admin/missions" className={getNavLinkClass} onClick={closeMenu}>
                  Missions
                </NavLink>
              </li>
              <li className={styles['nav-item']}>
                <NavLink to="/admin/tickettracking" className={getNavLinkClass} onClick={closeMenu}>
                  Suivi Tickets
                </NavLink>
              </li>
            </>
          )}

          {/* LIEN PARAMÈTRES (Pour TOUT LE MONDE : Admin et Consultant) */}
          <li className={styles['nav-item']}>
            <NavLink to="/settings" className={getNavLinkClass} onClick={closeMenu}>
              Paramètres
            </NavLink>
          </li>
        </ul>

        {/* MOBILE USER ACTIONS */}
        <div className={styles['mobile-user-actions']}>
          {user && (
            <span className={styles['mobile-user-info']}>
              Connecté en tant que<br />
              <strong>{user.email}</strong>
            </span>
          )}
          <button onClick={handleLogout} className={`${styles.btn} ${styles['btn-mobile-logout']}`}>
            Déconnexion
          </button>
        </div>
      </nav>

      {/* Actions Desktop (Logout + Hamburger) */}
      <div className={styles['navbar-actions']}>
        {/* On affiche le bouton de déconnexion desktop uniquement ici, le CSS le cache sur mobile */}
        <button onClick={handleLogout} className={`${styles.btn} ${styles['btn-secondary']}`}>
          Déconnexion
        </button>

        <button
          className={`${styles['navbar-toggle']} ${isMenuOpen ? styles.open : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Menu"
        >
          <span className={styles.bar}></span>
          <span className={styles.bar}></span>
          <span className={styles.bar}></span>
        </button>
      </div>
    </header>
  );
};

export default Navbar;